// src/tokens/effect/effect.ts
var effect = {
  blur: {
    primary: "12%"
  },
  shadow: {
    elevation1: "0px 8px 24px 0px rgba(0, 0, 0, 0.08), 0px 0px 4px 0px rgba(0, 0, 0, 0.12)",
    elevation2: "0px 18px 33px 0px rgba(0, 0, 0, 0.02), 0px 8px 40px 0px rgba(0, 0, 0, 0.10), 0px 0px 6px 0px rgba(0, 0, 0, 0.10)"
  }
};

export {
  effect
};
